import Icon from "../../../../../assets/spaceicons/form.svg";
import {
  SpaceComponentPackage,
  SpaceComponentHostType,
  SpaceComponentTags
} from "../../../../../types";
import { ElementLayout } from "../../../layout/util";
import ConfigPopover, {
  getSchema,
  errorSelector
} from "../common/FunctionBackedPopover";
import reducer, {
  ensureSubmittableComponent,
  makeInitialState,
  SubmittableComponent,
  SubmittableComponentConfigState,
  SubmittableComponentProps
} from "../common/FunctionBackedPopover/reducer/reducer";

import SpaceFunctionModalForm from "./SpaceFunctionModalForm";

const pkg: SpaceComponentPackage<
  SubmittableComponentProps,
  SubmittableComponent,
  SubmittableComponentConfigState
> = {
  type: "FUNCTION_MODAL_FORM",
  displayName: "Pop-up Form",
  Icon,
  allowedHosts: new Set<SpaceComponentHostType>([
    "HEADER",
    "TABLE",
    "DETAIL",
    "CARD_LIST",
    "FLEX_BOX"
  ]),
  Component: SpaceFunctionModalForm as any,
  ConfigurationComponent: ConfigPopover,
  componentConfigReducer: reducer,
  ensureComponent: ensureSubmittableComponent,
  getInitialDraftState: makeInitialState,
  getSchema,
  defaultElementLayout: new ElementLayout({
    width: "auto",
    height: "auto",
    snapToGrid: false
  }),
  allowSelfBinding: true,
  allowAncestorBinding: true,
  tags: [SpaceComponentTags.Base],
  isHeadless: false,
  errorSelector,
  isContainer: false
};

export default pkg;
